module.exports = __webpack_public_path__ + "static/media/bg_book.313bd1c7.jpg";